$(document).ready(function() {
	let addToCartPosition = $('.product-form__buttons').offset().top;
	let vpHeight = $(window).height() / 2;
	const windowWidth = $(window).width();
	var lastScrollTop = windowWidth > 750 ? addToCartPosition - 500 : addToCartPosition + 100;
	$(window).scroll(function(event){
		var st = $(this).scrollTop();
		if (st > lastScrollTop){
		  $('.fixed-top-button').addClass('show');
		} else {
		  $('.fixed-top-button').removeClass('show');
		  $('#pushdaddy-button').css({'bottom': '10px !important'});
		}
	});
}); 